import {
	get,
	post
} from './http'

export default {
	getFrequencyList(getOn, getOff, setDate, setTime) {
		return get('frequency/getfrequencyList', {
			geton: getOn,
			getoff: getOff,
			setdate: setDate,
			time: setTime
		});
	},
	getModelPlaceList(ModelID) {
		return get(
			'frequency/getModelPlaceList', {
				modelsid: ModelID
			});
	},
	getFrequencyInfo(freId) {
		return get(
			'frequency/getFrequencyInfo', {
				freid: freId
			});
	},
	getPickupAreaPriceList(city='中山市', ModelID = 7) {
		return get(
			'frequency/getPickupList', {
				city: city,
				modelid: ModelID
			});
	},
	getExtraServiceList(businessid, setdate, type) {
		return get(
			'Service/getServiceList', {
				businessid: businessid,
				setdate: setdate,
				type: type
			});
	},
	getGetOnList(businessid, type = 1, isgo = 1) {
		return get(
			'Frequency/getFrequencyGetOnList', {
				companyid: businessid,
				type: type,
				isgo: isgo
			});
	},
	getGetOffList(businessid, type = 1, isgo = 1) {
		return get(
			'Frequency/getFrequencyGetOffList', {
				companyid: businessid,
				type: type,
				isgo: isgo
			});
	},
	getAppointSetDateList(Airport, GoType) {
		return get('frequency/getAppointSetDateList', {
			airport: Airport,
			gotype: GoType
		});
	},
	getAppointFrequencyList(Airport, GoType, SetDate) {
		return get('frequency/getAppointFrequencyList', {
			airport: Airport,
			gotype: GoType,
			setdate: SetDate
		});
	}
}



// WEBPACK FOOTER //
// ./src/request/frequencyApi.js